import { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./footer.css";

interface Props {
    categories: string[]
}

export function Footer(props: Props) {
    const [searchText, setSearchText] = useState("");
    const navigate = useNavigate();

    function handleSearch() {
        if (searchText.length === 0)
            return;

        navigate(`/pesquisa/${searchText}`);
        setSearchText("");
    }

    return <div className="footer content-center">
        <div className="container">
            <div className="column-list">
                <div className="column logo-column">
                    <div className="logo">
                        <a href="/">
                            <svg id="Do7sCdyQw_" viewBox="0 0 390 107">
                                <defs id="SvgjsDefs1158"></defs>
                                <g id="SvgjsG1159" feature-key="rootContainer" transform="matrix(1,0,0,1,0,0)"
                                    fill="#6a2c70">
                                    <rect xmlns="http://www.w3.org/2000/svg" width="390" height="107" rx="10" ry="10">
                                    </rect>
                                </g>
                                <g id="SvgjsG1160" feature-key="q4o0QG-0"
                                    transform="matrix(4.3695381606415244,0,0,4.3695381606415244,17.727840239808735,-1.7603001233371174)"
                                    fill="#ffffff">
                                    <path
                                        d="M0.52 20 l0.24 -14.5 l2.38 -0.18 l1.08 0.12 l1.02 6.94 l0.6 -7.16 l4.1 0.5 c0.02 0.76 0.04 1.54 0.04 2.36 c0.08 1.38 0.18 3.18 0.18 4.84 c0.06 2.68 -0.02 4.6 0.16 7.12 l-1.76 -0.04 l-0.14 -8.98 l-0.38 -0.08 l-1 7.96 l-0.34 0.98 l-2.12 0.12 l-1.02 -8.4 l-0.6 0.14 l0.22 8.38 z M11.58 19.92 l-0.04 -6.94 l0.08 -0.74 l-0.04 -0.74 l0.1 -4.42 l0.18 -1.72 l6.5 0.12 l0.1 3.9 l-4.26 0 l-0.08 2.5 l3.26 -0.06 l0 0.22 l0.1 1.7 l-3.04 0.06 l0.1 2.96 l4.06 0.2 l0 3.08 z M25.820000000000004 12.64 l2.42 7.52 l-1.08 0 l-2.14 -0.1 l-1.46 -5.36 l-1.06 5.34 l-1.28 0.22 l-2.32 -0.22 l2.42 -7.38 l-2.42 -7.48 l1.9 0 l1.28 0.1 l1.06 4.96 l0.48 0.32 l0.38 -5.38 l1.54 -0.1 l2.7 0.14 l-2.42 7.1 l0 0.32 z M29.060000000000006 19.92 l-0.04 -6.94 l0.08 -0.74 l-0.04 -0.74 l0.1 -4.42 l0.18 -1.72 l6.5 0.12 l0.1 3.9 l-4.26 0 l-0.08 2.5 l3.26 -0.06 l0 0.22 l0.1 1.7 l-3.04 0.06 l0.1 2.96 l4.06 0.2 l0 3.08 z M38.88000000000001 7.699999999999999 l0.06 1.58 l0 2.06 l0.72 0 l0.7 -0.06 l0.46 -0.44 l0 -0.2 l0.08 -1.36 l-0.16 -1.22 l0 -0.04 l-0.22 -0.8 l-0.54 -0.24 l-1.04 0 z M38.760000000000005 5.24 l2.62 0.04 l1.24 0.14 l1.02 0.58 l0.8 1.32 l-0.26 3.86 l-0.32 0.6 l-1.18 0.38 l1.34 1 l0.36 0.98 l0 1.6 l-0.18 4.24 l-0.52 0.12 l-2.06 -0.1 l-0.1 -3.9 l-0.14 -2.06 l-0.48 -0.52 l-0.92 -0.3 l0 1.48 l0 3.72 l0.06 1.56 l-1.94 -0.02 l-0.92 0.06 l-0.32 -0.06 l0 -2.88 l0 -2.1 l0.12 -2.72 l-0.08 -4.68 l-0.04 -2.32 z M45.760000000000005 8.88 l3.2 0.08 l-0.16 2.5 l0.24 5.08 l-0.14 3.38 l-0.28 0.04 l-2.8 -0.06 l-0.12 -0.92 l-0.04 -5.36 z M45.88 4.98 l3.02 0.04 l0.14 0.78 l0 1.34 l-0.08 0.72 l-3.2 0.02 l-0.1 -1.3 l-0.04 -1.4 z M57.52 5.380000000000001 l0.52 0.34 l0.4 1.72 l0 2.84 l-0.36 6.42 l-0.64 1 l-0.46 0.2 l-2.8 -0.02 l-0.12 0.26 l0.86 0.4 l2.46 0.02 l0.2 1.58 l-1.82 0 l-1.7 0 l-1.22 -0.2 l-0.7 -0.66 l-0.22 -0.96 l0.1 -0.46 l-0.44 0 l-0.92 -0.68 l-0.14 -0.76 l0 -7.84 l0.44 -2.84 l1.46 -0.48 l2.22 -0.04 z M54.56 15.780000000000001 l1.42 -0.44 l0.2 -8.38 l-1.8 -0.16 l-0.52 0.3 l-0.02 5.38 l0.18 2.22 l0 0.44 l0.1 0.48 z M59.92 17.44 l0.1 -11.92 l0.78 -0.34 l2.4 0.14 l0.54 0.2 l-0.2 4.7 l-0.24 7.34 l0.8 1.08 l1.52 -0.32 l-0.12 -8.5 l0.12 -4.62 l1.9 0 l0.06 12.98 l-0.54 1.32 l-2.5 0.72 l-3.6 -0.5 z M69.18 19.92 l-0.04 -6.94 l0.08 -0.74 l-0.04 -0.74 l0.1 -4.42 l0.18 -1.72 l6.5 0.12 l0.1 3.9 l-4.26 0 l-0.08 2.5 l3.26 -0.06 l0 0.22 l0.1 1.7 l-3.04 0.06 l0.1 2.96 l4.06 0.2 l0 3.08 z M77.34 8.88 l3.2 0.08 l-0.16 2.5 l0.24 5.08 l-0.14 3.38 l-0.28 0.04 l-2.8 -0.06 l-0.12 -0.92 l-0.04 -5.36 z M77.46000000000001 4.98 l3.02 0.04 l0.14 0.78 l0 1.34 l-0.08 0.72 l-3.2 0.02 l-0.1 -1.3 l-0.04 -1.4 z">
                                    </path>
                                </g>
                            </svg>
                        </a>
                    </div>
                    <div className="input-button internal">
                        <input
                            className="search-input"
                            type="text"
                            name="search-input"
                            id="search-input-footer"
                            placeholder="O que você procura?"
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                        />
                        <button className="footer-search-button" onClick={() => handleSearch()}>
                            <i className="material-symbols-outlined">
                                search
                            </i>
                        </button>
                    </div>
                    <div className="footer-links">
                        <a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}&amp;src=sdkpreparse`} rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"
                                aria-label="Instagram" className="styled__Svg-sc-1j66vyb-0 gKUHbK">
                                <path
                                    d="M16.4461 1H7.55392C3.94007 1 1 3.94007 1 7.55392V16.4461C1 20.0599 3.94007 23 7.55392 23H16.4461C20.0599 23 23 20.0599 23 16.4461V7.55392C23 3.94007 20.0599 1 16.4461 1ZM20.7868 16.4461C20.7868 18.8434 18.8434 20.7868 16.4461 20.7868H7.55392C5.15663 20.7868 3.2132 18.8434 3.2132 16.4461V7.55392C3.2132 5.15659 5.15663 3.2132 7.55392 3.2132H16.4461C18.8434 3.2132 20.7868 5.15659 20.7868 7.55392V16.4461Z">
                                </path>
                                <path
                                    d="M12 6.31002C8.86254 6.31002 6.31002 8.86254 6.31002 12C6.31002 15.1374 8.86254 17.6899 12 17.6899C15.1375 17.6899 17.69 15.1374 17.69 12C17.69 8.8625 15.1375 6.31002 12 6.31002ZM12 15.4768C10.0798 15.4768 8.52322 13.9202 8.52322 12C8.52322 10.0798 10.0799 8.52322 12 8.52322C13.9202 8.52322 15.4768 10.0798 15.4768 12C15.4768 13.9202 13.9202 15.4768 12 15.4768Z">
                                </path>
                                <path
                                    d="M17.7011 7.71613C18.4541 7.71613 19.0645 7.1057 19.0645 6.3527C19.0645 5.59969 18.4541 4.98926 17.7011 4.98926C16.9481 4.98926 16.3376 5.59969 16.3376 6.3527C16.3376 7.1057 16.9481 7.71613 17.7011 7.71613Z">
                                </path>
                            </svg>
                        </a>
                        <a target="_blank" href={`https://twitter.com/intent/tweet?url=${window.location.origin}&text=Site Mexeriquei`} rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                                className="styled__Svg-sc-1j66vyb-0 fNRkt">
                                <path
                                    d="M20.23 6.679a7.21 7.21 0 01-2 .56 3.51 3.51 0 001.55-2 7.18 7.18 0 01-2.24.86 3.53 3.53 0 00-6 3.22 10 10 0 01-7.34-3.65 3.54 3.54 0 001.1 4.72 3.55 3.55 0 01-1.6-.45 3.54 3.54 0 002.83 3.47 3.649 3.649 0 01-1.6.06 3.54 3.54 0 003.3 2.47A7.1 7.1 0 013 17.409a10.06 10.06 0 0015.48-8.47v-.46a7.29 7.29 0 001.76-1.83l-.01.03z">
                                </path>
                            </svg>
                        </a>
                        <a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}&amp;src=sdkpreparse`} rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                                className="styled__Svg-sc-1j66vyb-0 fNRkt">
                                <path
                                    d="M16.185 8.82h-2.85V6.95a.76.76 0 01.64-.86h2.16V3h-2.77a3.51 3.51 0 00-3.77 3.22 5 5 0 000 .55v2.06h-1.78v3.18h1.78v9h3.74v-9h2.52l.33-3.18v-.01z">
                                </path>
                            </svg>
                        </a>
                        <a target="_blank" href={`https://api.whatsapp.com/send?text=${window.location.origin}`} rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                                className="styled__Svg-sc-1j66vyb-0 fNRkt">
                                <path fillRule="evenodd" clipRule="evenodd"
                                    d="M19.09 4.899A9.967 9.967 0 003.412 16.922L2 22.07l5.277-1.386c1.46.8 3.099 1.22 4.763 1.22A9.966 9.966 0 0019.09 4.9zm-7.05 15.336a8.26 8.26 0 01-4.212-1.147l-.303-.193-3.139.826.817-3.056-.193-.312a8.26 8.26 0 117.03 3.882zm4.544-6.195c-.248-.128-1.469-.725-1.698-.808-.23-.082-.395-.128-.56.12-.165.248-.643.807-.79.982-.146.174-.293.183-.541.055a6.8 6.8 0 01-2-1.23 7.636 7.636 0 01-1.387-1.735c-.146-.247 0-.367.11-.504.23-.272.438-.56.625-.863a.477.477 0 000-.431c-.065-.129-.56-1.35-.771-1.836-.211-.486-.422-.404-.579-.404h-.477a.918.918 0 00-.66.312 2.753 2.753 0 00-.918 2.074 4.882 4.882 0 001.018 2.533 11.124 11.124 0 004.259 3.754c.46.202.933.376 1.413.523a3.37 3.37 0 001.57.101 2.516 2.516 0 001.68-1.184 2.01 2.01 0 00.146-1.184c-.064-.1-.23-.165-.477-.284l.037.01z">
                                </path>
                            </svg>
                        </a>
                    </div>
                </div>
                <div className="column category-list">
                    <div className="footer-list">
                        <div className="list-title">
                            Assuntos
                        </div>
                        <ul className="footer-list-items">
                            {props.categories.map((category, index) => (
                                <li className="footer-list-item" key={index}>
                                    <Link to={`/categorias/${category}`}>{category}</Link>
                                </li>
                            ))}
                            <li className="footer-list-item">
                                <a href="/horoscopo">Horóscopo</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="column util-links">
                    <div className="footer-list">
                        <div className="list-title">
                            Links úteis
                        </div>
                        <ul className="footer-list-items">
                            <li className="footer-list-item">
                                <Link to="/contato">Contato</Link>
                            </li>
                            <li className="footer-list-item">
                                <Link to="/sobre">Sobre</Link>
                            </li>
                            <li className="footer-list-item">
                                <Link to="/politicas-de-privacidade">Política de Privacidade</Link>
                            </li>
                            <li className="footer-list-item">
                                <Link to="/termos-de-uso">Termos de uso</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="column contact-list">
                    <div>
                        <div className="footer-list">
                            <div className="list-title">
                                Fale conosco
                            </div>
                            <ul className="footer-list-items">
                                <li className="footer-list-item">
                                    <a href="#">fac@mexeriquei.com</a>
                                </li>
                                <li className="footer-list-item">
                                    <a href="#">(85) 99293-8350</a>
                                </li>
                                <li className="footer-list-item">
                                    <a href="#">(85) 99293-8350</a>
                                </li>
                            </ul>
                        </div>
                        <div className="footer-list">
                            <div className="list-title">
                                Whatsapp
                            </div>
                            <ul className="footer-list-items">
                                <li className="footer-list-item">
                                    <a href="#">(85) 99293-8350</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
            <div className="foooter-botton">
                <span>
                    © {new Date().getFullYear()} | Todos Os Direitos Reservados.
                    <br />
                    Desenhado e implementado, utilizando as melhores práticas, Por T. Rocha.
                </span>
            </div>
        </div>
    </div>
}